import { WholesaleFiber } from './offer-decider'
import { WholesaleFiberProductData } from './product-data-parser'

export default (raw, node) => {
  return new WholesaleFiber(new WholesaleFiberProductData(raw, node))
}
